import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
import { EatsPromotionProductsPage } from '@/pages/eats-promotions';
import { requireAuth } from '../require-auth';

const promotionProductsSearchSchema = z.object({
  search: z.string().optional(),
  category: z.string().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  allBranches: z.boolean().optional().catch(undefined),
});

export const Route = createFileRoute('/eats/menu_/promotions_/$promotionId')({
  beforeLoad: requireAuth,
  validateSearch: promotionProductsSearchSchema,
  component: PromotionProductsRoute,
});

function PromotionProductsRoute() {
  const { promotionId } = Route.useParams();
  const { search, category, from, to, allBranches } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <EatsPromotionProductsPage
      promotionId={promotionId}
      search={search}
      category={category}
      from={from}
      to={to}
      allBranches={allBranches ?? false}
      onSelectAllBranches={(next) => {
        void navigate({
          search: (prev) => ({ ...prev, allBranches: next ? true : undefined }),
        });
      }}
    />
  );
}
